// extracted by mini-css-extract-plugin
export var tos = "tos-module--tos--322aW";